// packages
import 'intersection-observer';
import yall from 'yall-js';
import Scroller from '@newswire/scroller';
import { createMap, addMarkers, showMarkers } from './components/map';

// local imports
import { AdLoader } from './ads/loader';

// Kickstart the ads
const adLoader = new AdLoader({ adSection: window.AD_SECTION });
adLoader.init();

// Kickstart the lazy image loading
document.addEventListener('DOMContentLoaded', yall);

let padding = { top: 0, bottom: 0, left: 0, right: 0 };

const reportWindowSize = () => {
  if (window.innerWidth < 801) {
    padding.left = 0;
    padding.bottom = window.innerHeight / 2;
  } else {
    padding.left = window.innerWidth / 2;
  }
};

const infoCards = window.CARDS.cards;
console.log(infoCards);
reportWindowSize();
window.map = createMap();

window.map.on('load', function () {
  addMarkers();

  const scenes = document.querySelectorAll('.scene');

  const scroller = new Scroller({
    container: document.querySelector('.scroller-container'),
    scenes: scenes,
    offset: 0.25,
  });

  const graphic = document.querySelector('.graphic');
  let imgSrc = document.querySelector('.map');

  scroller.on('scene:enter', function (d) {
    d.element.classList.add('is-active');
    const slug = d.element.getAttribute('slug');
    showMarkers(slug.split('-')[1]);
    const card = infoCards.find((d) => d.slug === slug);
    const coords = card.coords.split(', ');
    if (coords.length < 3) {
      window.map.flyTo({
        center: [coords[0], coords[1]],
        zoom: card.zoom,
        padding: padding,
        essential: true, // this animation is considered essential with respect to prefers-reduced-motion
      });
    } else {
      window.map.fitBounds([
        [parseFloat(coords[0]), parseFloat(coords[1])],
        [parseFloat(coords[2]), parseFloat(coords[3])],
      ]);
    }
  });

  scroller.on('container:enter', function (d) {
    console.log('enter:', d);
  });

  scroller.on('scene:exit', function (d) {
    d.element.classList.remove('is-active');
  });

  // scroller.on('container:exit', function(d) {
  //   console.log('exit:', d);
  //   graphic.textContent = 'Waiting to be activated';
  // });

  window.addEventListener('resize', reportWindowSize);

  scroller.init();
});
